<template>
    <div>
        <div v-if="params.componentName == 'Actuality'">
            <b-button v-if="params.iconType == 'feather'" :variant="params.variant" class="btn-icon" size="sm"
                style=" padding: 5px;" @click="params.onButtonClick(params.data)">
                <feather-icon :icon="params.icon" size="15" />
            </b-button>
            <b-button :disabled="!isProductsFetched && params.icon == 'shopping_cart'" v-else
                :variant="params.variant ? params.variant : 'outline-secondary'" class="btn-icon" size="sm"
                style=" padding: 0px;" @click="params.onButtonClick(params.data)">
                <i class="material-icons" style="width: 35px;height:0px">{{ params.icon }}</i>
            </b-button>
        </div>
        <div v-else-if="params.componentName == 'NewOrder'">
            <div v-if="params.data.No != ''">
                <b-button v-if="params.iconType == 'feather'" :variant="params.variant" class="btn-icon" size="sm"
                    style=" padding: 5px;" @click="params.onButtonClick(params.data)">
                    <feather-icon :icon="params.icon" size="15" />
                </b-button>
                <b-button v-else :variant="params.variant ? params.variant : 'outline-secondary'" class="btn-icon" size="sm"
                    style=" padding: 0px;" @click="params.onButtonClick(params.data)">
                    <i class="material-icons" style="width: 35px;height:0px">{{ params.icon }}</i>
                </b-button>
            </div>
        </div>
        <div v-else>
            <b-button v-if="params.iconType == 'feather'" :variant="params.variant" class="btn-icon" size="sm"
                style=" padding: 5px;" @click="params.onButtonClick(params.data)">
                <feather-icon :icon="params.icon" size="15" />
            </b-button>
            <b-button v-else :variant="params.variant ? params.variant : 'outline-secondary'" class="btn-icon" size="sm"
                style=" padding: 0px;" @click="params.onButtonClick(params.data)">
                <i class="material-icons" style="width: 35px;height:0px">{{ params.icon }}</i>
            </b-button>
        </div>
    </div>
</template>
  
<script>

export default {
    computed: {
        isProductsFetched() {
            return this.$store.getters["app-portaldata/isProductsFetched"];
        },
    },
};
</script>
  
<style scoped></style>
  